import React, {useState, useEffect} from "react";
import stateMap from "store/stateMap";
import { connect } from 'react-redux';
import { StarsList } from "component/Rating";

import api from "api";
import Sidebar from "component/Sidebar";
import { RatingCardList, RatingInitiativeCardList } from "component/Rating";
import { useFormik } from "formik";
import _ from "lodash";
import "./index.scss";
import {ReactComponent as SVGSearch} from './../../../assets/search.svg';
import { PageCredential } from "component/PageCredential";

const PageProfileRating = connect(stateMap)((props) => {
    const [displayedRating, setDisplayedRating]     = useState('received');
    const [userRating, setUserRating]               = useState(false);
    const [ratingSortBy, setRatingSortBy]           = useState('UserRating.RateDate');
    const [ratingSort, setRatingSort]               = useState('DESC');
    const [ratingSearch, setRatingSearch]           = useState('');
    const [ratingRefresh, setRatingRefresh]           = useState(0);

    const formik = useFormik({
        initialValues : {
            search : ''
            ,sort : ''
        }
        ,onSubmit : (value) => {


            if(value.sort == 'alphabet')
            {
                if(displayedRating == 'given')
                {
                    setRatingSortBy('User.UserFirstName');
                    setRatingSort('ASC');
                }
                else
                {
                    setRatingSortBy('Initiative.Title');
                    setRatingSort('ASC');
                }
            }

            setRatingSearch(value.search);

            setRatingRefresh(Date.now());

        }
    })


    useEffect(() => {
        if(!props.auth.user)
        {
            return;
        }

        api('/Profile/Rating', 'get', {
            user_id : props.auth.user.UserID
        }).then(response => {
            setUserRating(response.rating);
        });

    }, [props.auth.user]);

    return (
        <>
            <PageCredential title={"My Rating"} />
            <div className="page-profile-rating container relative">
                <Sidebar>
                    <div className="initiatives-filters filters-boxes">
                        <div className="rating-information">
                        {
                            userRating === false ? <span className="skeleton"></span> :
                            <>
                                <span className="block bold mb-md text-sm ">Your Rating</span>
                                <div className="flex flex-wrap">
                                    <span className="block font-bold user-score">{userRating}</span>&nbsp;
                                    <StarsList score={userRating}/>
                                </div>
                            </>
                        }
                        </div>
                        <hr />
                        <div className="filter-box">
                            <div className="wrapper">
                                <div className="filter-body">
                                    <ul className="filter-items">
                                        <li className={`filter-item ${displayedRating == 'given' && 'active'}`}><a href="#"  onClick={(e) => {
                                            e.preventDefault();
                                            setDisplayedRating('given');
                                        }} >Given</a></li>
                                        <li className={`filter-item ${displayedRating == 'received' && 'active'}`}><a href="#"  onClick={(e) => {
                                            e.preventDefault();
                                            setDisplayedRating('received');
                                        }}>Received</a></li>
                                        <li className={`filter-item ${displayedRating == 'testimonial' && 'active'}`}><a href="#"  onClick={(e) => {
                                            e.preventDefault();
                                            setDisplayedRating('testimonial');
                                        }}>Testimonial</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Sidebar>
                <div className="profile-rating-container">
                {
                    displayedRating != 'testimonial' &&
                    <form action="" className="generic-form " onSubmit={formik.handleSubmit}>
                        <div className="field-group ">
                            <span className="label block">Sort : </span>
                            <div className="fancy-select">
                                <select value={formik.values.sort} onBlur={formik.handleBlur} onChange={(e) => {
                                    formik.handleChange(e);
                                    
                                    formik.submitForm();

                                }} name="sort">
                                    <option value="">Newest</option>
                                    <option value="alphabet">Alphabet</option>
                                </select>
                            </div>
                        </div>
                        <div className="field-group">
                            <span className="input-icon-wrapper">
                                <input
                                    value={formik.values.search} onBlur={formik.handleBlur} onChange={formik.handleChange} onKeyDown={e => {

                                        if(e.code == 'Enter')
                                        {
                                            e.preventDefault();

                                            formik.submitForm();
                                        }
                                    }} name="search" 
                                    type="text" className="text form-control rounded" placeholder="Search" />
                                    <SVGSearch/>

                            </span>
                        </div>
                    </form>
                    }
                    {
                        props.auth.user && displayedRating == 'received' && 
                        <RatingInitiativeCardList listArgs={{
                            user_id : props.auth.user.UserID
                            ,posts_per_page : 2
                            ,sortby : ratingSortBy
                            ,sort   : ratingSort
                            ,search : ratingSearch
                            ,refresh : ratingRefresh
                        }}/>
                    }
                    {
                        props.auth.user && displayedRating == 'given' && 
                        <RatingCardList listArgs={{
                            sender_id : props.auth.user.UserID
                            ,posts_per_page : 2
                            ,sortby : ratingSortBy
                            ,sort   : ratingSort
                            ,search : ratingSearch
                            ,refresh : ratingRefresh
                        }} userToDisplay="User_"/>
                    }
                    {
                        props.auth.user && displayedRating == 'testimonial' && 
                        <RatingCardList listArgs={{
                            user_id : props.auth.user.UserID
                            ,posts_per_page : 2
                            ,has_message : 1
                            ,sortby : ratingSortBy
                            ,refresh : ratingRefresh
                        }} userToDisplay="Sender_"/>
                    }
                </div>
            </div>
        </>
    )
});

export default PageProfileRating;